import '../css/app.scss';
import Burger from './components/burger';
import Filter from './components/filter';
import Header from './components/header';
import Scroll from './components/scroll';
import Slider from './components/slider';
import ProjectTeaser from './components/projectTeaser';
import Gallery from './components/gallery';
import Loader from './components/loader';
import Accordion from './components/accordion';
import DatePicker from './components/datePicker';
import TimelineGallery from './components/historySlider';





/** Global Components */

/** Bootstrap */

$(() => {

	// init global components
	const $burger = $('[data-burger="el"]');
	new Burger($burger);

	const $header = $('[data-header="el"]');
	new Header($header);


	const $filter = $('[data-filter="el"]');
	new Filter($filter);

	const $scrollImages = $('[data-scroll="image"]');
	const $fadeIn = $('[data-scroll="fade-in"]');
	new Scroll($fadeIn, $scrollImages);

	const $slider = $('[data-slider="el"]');
	$slider.each((i,el) => {
		new Slider($(el))
	})


	const $projectTeaser = $('[data-teaser="el"]');
	$projectTeaser.each((i, el) => {
		new ProjectTeaser($(el));
	})

	const $scrollUp = $('[data-scrollUp="el"]');

	$scrollUp.on('click', function () {
		window.scrollTo({ top: 0, behavior: 'smooth' });
	});

	const $gallery = $('[data-gallery="el"]');
	$gallery.each((i, el) => {
		new Gallery($(el));

	});

	const $loader = $('[data-loader="el"]');
	if($loader.length){
		new Loader($loader);
		

	}
	else {
		$('body').addClass('ready');
		window.CookieConsent.show();

	}

	$('[data-gallery="el"]').each((i, el) => new TimelineGallery($(el)));

const $accordion = $('[data-accordion="el"]');
$accordion.each((i, el) => {
    new Accordion($(el));
});
	
const $datePicker = $('[data-datePicker="el"]');
$datePicker.each((i, el) => {
	new DatePicker($(el));
})



});
